<template>
  <v-container>
    <v-layout
      text-xs-left
      wrap
    >
    <div v-if="authenticated">
      <v-flex xs12>
        <v-img
          :src="require('../assets/logo-soma-square.svg')"
          class="my-3"
          contain
          height="200"
        ></v-img>
      </v-flex>

      <v-flex mb-4>
        <h1 class="display-2 font-weight-bold mb-3">
          Notify Page
        </h1>
      </v-flex>
    </div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
    data() {
        return {}
    },
    computed: {
        ...mapState([
            'authenticated'
        ])
    }
  }
</script>

<style>
</style>
